
























































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import HMVueEditorPreview from '@/web/components/common/HMVueEditorPreview.vue';
import { saveAs } from '@/web/utils/save-file';

interface Note {
  id?: number;
  title: string;
  note: string;
  updated: string;
  attachments?: any[];
}

export default Vue.extend({
  components: {
    ValidationObserver,
    HMVueEditorPreview,
  },
  props: {
    note: {
      type: Object as () => Note,
      required: true,
    },
    customerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      downloadingNote: false,
    };
  },
  methods: {
    async downloadNote() {
      this.downloadingNote = true;
      try {
        const data = await this.$store.dispatch('sale/downloadCustomerNote', {
          customerId: this.customerId,
          noteId: this.note.id,
        });
        const blob = new Blob([data], {
          type: 'application/pdf;charset=utf-8;',
        });

        const name = this.note.title || `note-${this.note.id}`;
        saveAs(blob, `${name}.pdf`);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.ATTACHMENT_ERROR'),
        });
      }
      this.downloadingNote = false;
      this.$emit('close');
    },
    editNote() {
      const params = {
        customerId: this.customerId,
        id: this.note.id,
      };

      this.$router.push({ name: 'CustomerEditNote', params });
      this.$parent.$emit('editNote');
      this.$emit('close');
    },
  },
});
